module.exports = __webpack_public_path__ + "assets/icon-conductor-paddockTape.ab22a215.svg";